import { useAuth } from "#root/components/auth";
import { AutoCompleteField, BooleanSelectField, CategoryNameField, CompanyNameField, CurrencyField, DateField, DeleteField, DomainField, EmailField, FieldSet, FullNameField, GenericNameField, HiddenField, InputField, IntegerField, JSONEditorField, Markdown, NumberField, ObjectCodeField, OptionField, PasswordConfirmField, PasswordField, PhoneField, ProductNameField, SelectField, StringField, SubmitField, TagsField, TextAreaField, TimeIntervalField, TimeOfDayField, TimestampField, TimezoneField, TaxIDField, UUIDField, ValidityIndicator, WebsiteURIField } from "#root/components/form/fields";
import StandardEditor from "#root/components/standard-editor";
import RemoteCollection from "#root/utility/remote-collection";
import type { ReactNode } from "react";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { z } from "zod";

import PageLayout from "./layout";
import BackgroundHeader from "#root/components/background-header";

const LoginListItemSchema = z.any();

const loginCollection = new RemoteCollection("/api/login", LoginListItemSchema, LoginListItemSchema);

export default function (): ReactNode {
  const navigate = useNavigate();
  const auth = useAuth();
  const handleSave = useCallback(
    ({ authToken }: { authToken?: string }) => {
      //TODO: authToken should be passed in via the row, right now it is returned in a non-conforming way
      auth.setLoginCredentials(authToken!);
      navigate("/account/profile");
    },
    [navigate, auth],
  );

  return (
    <PageLayout title="Login">
      <BackgroundHeader>
        <div className="text-white w-full max-w-200 py-16">
          <h1 className="border-b-0 text-white text-4xl m-0">Welcome Back</h1>
          <p className="text-white text-xl my-[0.8rem]">Log in to your CloudQuote account</p>
        </div>
      </BackgroundHeader>

      <section className="flex-none m-0 px-8 py-16 bg-[#f9f9fb]">
        <div className="max-w-2xl mx-auto bg-white border border-[#eee] rounded-lg shadow-[0_2px_8px_rgb(0_0_0/0.06)] p-12">
          <div className="mb-8">
            <h2 className="text-2xl font-bold text-[#1a1a2e] m-0 mb-2">Sign in</h2>
            <p className="text-[#666] text-base m-0">Enter your credentials to access your account.</p>
          </div>
          <StandardEditor collection={loginCollection} buttonOptions={{ save: { position: "bottom", label: "Login" } }} onSave={handleSave}>
            <FieldSet name="email">
              <label>Email Address</label>
              <EmailField required autoComplete="email"/>
              <ValidityIndicator/>
            </FieldSet>
            <FieldSet name="password">
              <label htmlFor="password">Password</label>
              <PasswordField required autoComplete="current-password"/>
              <ValidityIndicator/>
            </FieldSet>
          </StandardEditor>
        </div>
      </section>
    </PageLayout>
  );
}
